export const AUTH_ACTIONS = {
  LOGIN: 'LOGIN',
  LOGOUT: 'LOGOUT',
  SET_TOKEN: 'SET_TOKEN',
  SET_LOADING: 'SET_LOADING',
  SET_ASSETS_LOADING: 'SET_ASSETS_LOADING',
  SET_USER: 'SET_USER',
};
